import { call, takeLatest, put } from "redux-saga/effects";
import { callApi } from "../../util/superAgentUtil";
import actions from "../actionType";
import { notification } from "../../util/notification";
import formatMsg from "../../util/formatMsg";
import Helper from "../../util/helper";
import { timeutil } from "../..";

export function* createRoleSaga(request) {
    try {
        const { firebase, payload } = request.payload;

        let endpoint = "bookingoApi/accessControl/createRole";
        payload.createdBy = firebase?.teacher?.id;
        payload.createdOn = timeutil.getEpoch();
        let response = yield call(callApi, firebase, "post", endpoint, payload);

        if (response.status == 200) {
            notification("success", formatMsg("roleCreatedSuccessfully"));
            yield put({
                type: actions.ROLES_REQ_SUCCESS,
                payload: {
                    operationType: "ROLE_CREATE_SUCCESS",
                    isLoading: false,
                    createdRole: response.body.data
                }
            });
        } else {
            notification("error", response?.body?.data?.message || formatMsg("error.occured"));
            yield put({ type: actions.ROLES_REQUEST_FAILED });
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ROLES_REQUEST_FAILED });
        console.log("failed to create role", err);
    }
}

export function* getRoleListSaga(request) {
    try {
        const { firebase } = request.payload;

        let endpoint = "bookingoApi/accessControl/roleList";
        let response = yield call(callApi, firebase, "get", endpoint, {});

        if (response.status == 200) {
            yield put({
                type: actions.ROLES_REQ_SUCCESS,
                payload: {
                    isLoading: false,
                    roleList: response.body.data || []
                }
            });
        } else {
            notification("error", response?.body?.data?.message || formatMsg("error.occured"));
            yield put({ type: actions.ROLES_REQUEST_FAILED });
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ROLES_REQUEST_FAILED });
        console.log("failed to get role list", err);
    }
}

export function* getAllPermissionsSaga(request) {
    try {
        const { firebase } = request.payload;

        let endpoint = "bookingoApi/accessControl/permissionList";
        let response = yield call(callApi, firebase, "get", endpoint, {});

        if (response.status == 200) {
            yield put({
                type: actions.ROLES_REQ_SUCCESS,
                payload: {
                    isLoading: false,
                    permissions: response.body.data || []
                }
            });
        } else {
            notification("error", response?.body?.data?.message || formatMsg("error.occured"));
            yield put({ type: actions.ROLES_REQUEST_FAILED });
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ROLES_REQUEST_FAILED });
        console.log("failed to get permissions", err);
    }
}

export function* getRolePermissionsSaga(request) {
    try {
        const { firebase, roleId } = request.payload;

        let endpoint = `bookingoApi/accessControl/rolePermissions/${roleId}`;
        let response = yield call(callApi, firebase, "get", endpoint, {});

        if (response.status == 200) {
            yield put({
                type: actions.ROLES_REQ_SUCCESS,
                payload: {
                    isLoading: false,
                    rolePermissions: response.body.data?.data || []
                }
            });
        } else {
            notification("error", response?.body?.data?.message || formatMsg("error.occured"));
            yield put({ type: actions.ROLES_REQUEST_FAILED });
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ROLES_REQUEST_FAILED });
        console.log("failed to get role permissions", err);
    }
}

export function* updateRoleSaga(request) {
    try {
        const { firebase, roleId, payload } = request.payload;

        let endpoint = `bookingoApi/accessControl/updateRole/${roleId}`;
        let response = yield call(callApi, firebase, "post", endpoint, payload);

        if (response.status == 200) {
            notification("success", formatMsg("roleUpdatedSuccessfully"));
            yield put({
                type: actions.ROLES_REQ_SUCCESS,
                payload: {
                    operationType: "ROLE_UPDATE_SUCCESS",
                    isLoading: false,
                    updatedRole: response.body.data?.data
                }
            });
        } else {
            notification("error", response?.body?.data?.message || formatMsg("error.occured"));
            yield put({ type: actions.ROLES_REQUEST_FAILED });
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ROLES_REQUEST_FAILED });
        console.log("failed to update role", err);
    }
}

export function* deleteRoleSaga(request) {
    try {
        const { firebase, roleId } = request.payload;

        let endpoint = `bookingoApi/accessControl/deleteRole/${roleId}`;
        let response = yield call(callApi, firebase, "delete", endpoint, {});

        if (response.status == 200) {
            notification("success", formatMsg("roleDeletedSuccessfully"));
            yield put({
                type: actions.ROLES_REQ_SUCCESS,
                payload: {
                    operationType: "ROLE_DELETE_SUCCESS",
                    isLoading: false
                }
            });
        } else {
            notification("error", response?.body?.data?.message || formatMsg("error.occured"));
            yield put({ type: actions.ROLES_REQUEST_FAILED });
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({ type: actions.ROLES_REQUEST_FAILED });
        console.log("failed to delete role", err);
    }
}

export function* assignPermissionsSaga(request) {
    try {
        const { firebase, payload } = request.payload;

        let endpoint = `bookingoApi/accessControl/assignPermissions`;
        let response = yield call(callApi, firebase, "post", endpoint, payload);

        if (response.status == 200) {
            notification("success", "Permissions updated successfully");

            // Check if logged-in teacher has the role for which permissions are updated
            const { roleName } = payload;
            const loggedInTeacher = firebase?.teacher;

            // Check if logged-in teacher has the role that was updated
            const hasMatchingRole = loggedInTeacher?.roles?.some(role => role.roleName === roleName);

            if (loggedInTeacher && hasMatchingRole && !loggedInTeacher.isSuperAdmin) {
                // Fetch updated permission map for logged-in teacher
                try {
                    const permissionResponse = yield call(callApi, firebase, "get", `bookingoApi/teacher/${loggedInTeacher.id}/permissions`, {});
                    if (permissionResponse.status === 200) {
                        const permissionData = permissionResponse.body.data;
                        const updatedPermissionMap = permissionData.permissions || {};

                        // Update firebase teacher with new permissions
                        const updatedTeacher = { ...loggedInTeacher, permissionMap: updatedPermissionMap };
                        yield put({
                            type: actions.SET_FIREBASE_OBJ,
                            payload: { teacher: updatedTeacher }
                        });
                    }
                } catch (permissionErr) {
                    console.log("Failed to fetch updated permission map:", permissionErr);
                }
            }

            yield put({
                type: actions.ROLES_REQ_SUCCESS,
                payload: {
                    operationType: "PERMISSIONS_ASSIGN_SUCCESS",
                    isLoading: false
                }
            });
        } else {
            notification("error", response?.body?.data?.message || formatMsg("error.occured"));
            yield put({
                type: actions.ROLES_REQ_SUCCESS,
                payload: {
                    operationType: "PERMISSIONS_ASSIGN_FAILED",
                    isLoading: false
                }
            });
        }
    } catch (err) {
        Helper.notifyBugsnag(err, true);
        yield put({
            type: actions.ROLES_REQ_SUCCESS,
            payload: {
                operationType: "PERMISSIONS_ASSIGN_FAILED",
                isLoading: false
            }
        });
        console.log("failed to assign permissions", err);
    }
}

export default function* rootSaga() {
    yield takeLatest(actions.CREATE_ROLE, createRoleSaga);
    yield takeLatest(actions.GET_ROLE_LIST, getRoleListSaga);
    yield takeLatest(actions.GET_ALL_PERMISSIONS, getAllPermissionsSaga);
    yield takeLatest(actions.GET_ROLE_PERMISSIONS, getRolePermissionsSaga);
    yield takeLatest(actions.UPDATE_ROLE, updateRoleSaga);
    yield takeLatest(actions.DELETE_ROLE, deleteRoleSaga);
    yield takeLatest(actions.ASSIGN_PERMISSIONS, assignPermissionsSaga);
}
